import React from 'react';
import { AuthRoleEnum } from '@codezo/graphql';
import { Navigate, useLocation } from 'react-router-dom';

interface PrivateRouteProps<TUser extends { role: AuthRoleEnum }> {
	children: React.ReactNode;
	requiredRole?: AuthRoleEnum;
	isAuthenticated: boolean;
	user: TUser | null;
}

export function PrivateRoute<TUser extends { role: AuthRoleEnum }>({
	children,
	requiredRole,
	isAuthenticated,
	user,
}: PrivateRouteProps<TUser>) {
	const location = useLocation();

	if (!isAuthenticated || (requiredRole && user?.role !== requiredRole)) {
		return (
			<Navigate to={`/auth/reauth#prevPath=${location.pathname}${location.search}`} replace />
		);
	}

	return <>{children}</>;
}
